// extracted by mini-css-extract-plugin
module.exports = {"blockClick":"TransactionHistory_blockClick_3dBJ3"};